/**
 * exercise-applicability-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='applicable-dogs-section']",
    title: "Dog Applicability",
    ...tourStepProps,
    placementBeacon: 'left',
    placement: 'bottom',
    spotlightPadding: 0,
    isFixed: true,
    content: (
      <TourStep>
        Some exercises in the event will only apply to certain dogs.
        For example, some dogs may be trained to track while others are trained to detect specific odors.
        Only applicable exercises need to be completed and added to your K9's records.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='applicable-dogs-section']",
    title: "Dog Applicability",
    ...tourStepProps,
    placement: 'top',
    spotlightClicks: true,
    isFixed: true,
    content: (
      <TourStep>
        To see the list of dogs which are applicable to this exercise just click the arrow on the far right to expand the section.
      </TourStep>
    ),
  }
];
